import { TextField, Select, Skeleton, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getOrderList } from "../../../../Services/Api";

export const OrderFields = (props) => {
  const {
    value,
    onChange,
    disabled
  } = props
  const { data, isLoading, isError } = useQuery({
    queryKey: ['getOrderList'],
    queryFn: getOrderList,
    refetchInterval: 30000
  })
  if (isLoading && !data) return (<Skeleton variant="rectangular" width={444} height={40} />)
  if (!data || !Array.isArray(data?.payload)) return (
    <div style={{width: "444px" }}>
      <TextField
        InputLabelProps={{ shrink: true }}
        label="Номер заказа"
        size="small"
        value={value}
        onChange={(e) => onChange(e?.target?.value || e)}
        disabled={disabled}
        fullWidth
      />
    </div>

  )
  //TODO: Заменить на селект
  const additionalData = [{ value: '', label: (<em>Не задан</em>) }, ...data.payload]
  const intVal = additionalData.map(({ value: v = '---------!!!!!!!!!' }) => v).includes(value) ? value : ''
  // console.log('!!!value', intVal, value, )
  return (
    <div style={{ marginTop: "-16px", width: "444px" }}>

      <FormControl variant="outlined" sx={{ m: 1, minWidth: 120 }} size="small" fullWidth>
        <InputLabel id="order-label">Номер заказа</InputLabel>
        <Select
          sx={{ m: 1, minWidth: 120 }}
          labelId="order-label"
          id="order"
          value={intVal}
          size="small"
          disabled={disabled}
          label="Номер заказа"
          onChange={(e) => {
            console.log('!!!e', e, e?.target?.value)
            onChange(e?.target?.value || e)
          }}
        >
          {additionalData.map(({ value, label }) => (<MenuItem value={value}>{label}</MenuItem>))}
        </Select>
      </FormControl>
    </div>

  )
}